import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import './Input.css';

export function Input({
  label,
  error,
  helper,
  icon: Icon,
  className = '',
  id,
  required,
  type = 'text',
  ...props
}) {
  const [showPassword, setShowPassword] = useState(false);
  const inputId = id || (label ? label.toLowerCase().replace(/\s+/g, '-') : undefined);
  const isPassword = type === 'password';
  const effectiveType = isPassword ? (showPassword ? 'text' : 'password') : type;

  return (
    <div className={`input-field-group ${className}`}>
      {label && (
        <label htmlFor={inputId} className="input-label">
          {label} {required && <span className="input-required">*</span>}
        </label>
      )}
      <div className="input-wrapper">
        {Icon && <Icon size={16} className="input-leading-icon" />}
        <input
          id={inputId}
          type={effectiveType}
          className={`input-control ${Icon ? 'input-has-icon' : ''} ${isPassword ? 'input-has-trailing' : ''} ${error ? 'input-error' : ''}`}
          required={required}
          {...props}
        />
        {isPassword && (
          <button
            type="button"
            className="input-password-toggle"
            onClick={() => setShowPassword((prev) => !prev)}
            aria-label={showPassword ? 'Hide password' : 'Show password'}
            title={showPassword ? 'Hide password' : 'Show password'}
            tabIndex={-1}
          >
            {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        )}
      </div>
      {error && <span className="input-error-msg">{error}</span>}
      {helper && !error && <span className="input-helper-msg">{helper}</span>}
    </div>
  );
}

export function Select({
  label,
  error,
  helper,
  children,
  className = '',
  id,
  required,
  ...props
}) {
  const selectId = id || (label ? label.toLowerCase().replace(/\s+/g, '-') : undefined);

  return (
    <div className={`input-field-group ${className}`}>
      {label && (
        <label htmlFor={selectId} className="input-label">
          {label} {required && <span className="input-required">*</span>}
        </label>
      )}
      <div className="select-wrapper">
        <select
          id={selectId}
          className={`select-control ${error ? 'input-error' : ''}`}
          required={required}
          {...props}
        >
          {children}
        </select>
      </div>
      {error && <span className="input-error-msg">{error}</span>}
      {helper && !error && <span className="input-helper-msg">{helper}</span>}
    </div>
  );
}

export function Textarea({
  label,
  error,
  helper,
  className = '',
  id,
  required,
  rows = 4,
  ...props
}) {
  const textareaId = id || (label ? label.toLowerCase().replace(/\s+/g, '-') : undefined);

  return (
    <div className={`input-field-group ${className}`}>
      {label && (
        <label htmlFor={textareaId} className="input-label">
          {label} {required && <span className="input-required">*</span>}
        </label>
      )}
      <textarea
        id={textareaId}
        rows={rows}
        className={`textarea-control ${error ? 'input-error' : ''}`}
        required={required}
        {...props}
      />
      {error && <span className="input-error-msg">{error}</span>}
      {helper && !error && <span className="input-helper-msg">{helper}</span>}
    </div>
  );
}
